export var EntraIdSelectionMode;
(function (EntraIdSelectionMode) {
    EntraIdSelectionMode["ENTRA_ID_SELECTION_MODE_UNSPECIFIED"] = "ENTRA_ID_SELECTION_MODE_UNSPECIFIED";
    EntraIdSelectionMode["ENTRA_ID_SELECTION_MODE_ALL"] = "ENTRA_ID_SELECTION_MODE_ALL";
    EntraIdSelectionMode["ENTRA_ID_SELECTION_MODE_SPECIFIC"] = "ENTRA_ID_SELECTION_MODE_SPECIFIC";
    EntraIdSelectionMode["ENTRA_ID_SELECTION_MODE_NONE"] = "ENTRA_ID_SELECTION_MODE_NONE";
})(EntraIdSelectionMode || (EntraIdSelectionMode = {}));
